// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "stylesheets/" + {"150":"clanwars","424":"patrols","504":"treasury"}[chunkId] + ".chunk.css";
};